// extracted by mini-css-extract-plugin
export default {"active":"__main_active__swZGT","tmp":"__main_tmp__swZGT"};